import moment from 'moment';

type unitOfTimeType = 'years' | 'months' | 'weeks' | 'days' | 'hours' | 'minutes' | 'seconds';

export const DATE_MDY = (dateObj: any): string => {
	return moment.utc(dateObj).format('MM/DD/YYYY');
};

export const DATE_TIME = (dateObj: any): string => {
	return moment(dateObj).format('MM/DD/YYYY HH:mm:ss');
};

export const DATE_YMD = (dateObj: any): string => {
	return FORMAT_DATE(dateObj, 'YYYY-MM-DD');
};

export const DATE_MDY_LOCAL = (dateObj: any): string => {
	return FORMAT_DATE(dateObj, 'MM/DD/YYYY');
};

export const FORMAT_DATE = (dateObj: any, format: string): string => {
	return moment(dateObj).format(format);
};

export const YMD_TO_MOMENT = (dateString: string): moment.Moment => {
	return moment(dateString, 'YYYY-MM-DD');
};

export const IS_EXISTING_DATE = (dateValue: string) => {
	return moment(dateValue, 'L').isValid();
};

export const IS_LESS_THAN_CURRENT_TIMESTAMP = (expiresAt: any): boolean => {
	return moment(expiresAt) < moment();
};

export const CALCULATE_TRANSIT_DAYS = (pickupDate, deliveryDate): number => {
	if (pickupDate != 'Unknown' && deliveryDate != 'Unknown') {
		return moment(deliveryDate).diff(moment(pickupDate), 'days');
	} else if (deliveryDate != null) {
		return deliveryDate;
	} else {
		return 1;
	}
};

export const TIMESTAMP_FROM_STRING = (obj: any): any => {
	return moment(obj).toISOString();
};

export const ADD_DAYS = (obj: any, daysToAdd: number): string => {
	return moment(obj).add(daysToAdd, 'days').format('MM/DD/YYYY');
};

export const YESTERDAY = (): moment.Moment => {
	return moment().subtract(1, 'days');
};

export const TODAY = (): moment.Moment => {
	return moment();
};

export const TOMORROW = (): moment.Moment => {
	return moment().add(1, 'days');
};

export const AFTER_7_DAYS = (): moment.Moment => {
	return moment().add(6, 'days');
};

export const AFTER_30_DAYS = (): moment.Moment => {
	return moment().add(29, 'days');
};

export const AFTER_90_DAYS = (): moment.Moment => {
	return moment().add(89, 'days');
};

export const END_OF_MONTH_MOMENT_OBJ = (): moment.Moment => {
	return moment().endOf('month');
};

export const START_OF_NEXT_MONTH = (): moment.Moment => {
	return moment().add(1, 'month').startOf('month');
};

export const END_OF_NEXT_MONTH = (): moment.Moment => {
	return moment().add(1, 'month').endOf('month');
};

export const GET_MOMENT = (): string => {
	return TODAY().format('MM/DD/YYYY');
};

export const START_OF_MONTH = (): string => {
	return moment().startOf('month').format('MM-DD-YYYY');
};

export const END_OF_MONTH = (): string => {
	return moment().endOf('month').format('MM-DD-YYYY');
};

export const DIFFERENCE_IN_DAYS = (startDate, endDate): number => {
	return moment(endDate).diff(moment(startDate), 'days') + 1;
};

export const IS_VALID_DATE = (dateValue: string, acceptedFormats: string[]) => {
	return moment(dateValue, acceptedFormats, true).isValid();
};

export const GET_UTC_DATE = (localDate: string) => {
	let dateValue = moment(localDate).utc().format('YYYY-MM-DD HH:mm');
	return moment.utc(dateValue).format('YYYY-MM-DD');
};

export const TO_UTC = (localDate: moment.Moment): moment.Moment => {
	return localDate.utc();
};

export const FROM_UTC = (utcDate: any): moment.Moment => {
	return moment.utc(utcDate).local();
};

export const ENUMERATE_DAYS_BETWEEN_DATES = (startDate: any, endDate: any): string => {
	startDate = moment(startDate);
	endDate = moment(endDate);
	let now = startDate,
		dates = [];
	while (now.isBefore(endDate) || now.isSame(endDate)) {
		dates.push(now.format('YYYY-MM-DD'));
		now.add(1, 'days');
	}
	return dates.join(', ');
};

export const GET_UNIX_TIMESTAMP = (dateobj: any): any => {
	return moment(dateobj).unix();
};

export const SUBTRACT_DAYS_FROM_TODAY = (daysToSubtract: number): moment.Moment => {
	return moment().subtract(daysToSubtract, 'days');
};

export const SUBTRACT_FROM_TODAY = (
	durationToSubtract: number,
	unitOfTime: unitOfTimeType
): moment.Moment => {
	return moment().subtract(durationToSubtract, unitOfTime);
};

export const SET_TIME_TO_START_OF_THE_DAY = (date: any): moment.Moment => {
	return moment(date).startOf('day');
};

export const SET_TIME_TO_END_OF_THE_DAY = (date: any): moment.Moment => {
	return moment(date).endOf('day');
};

export const DIFFERENCE_FROM_NOW = (dateInUtc: Date, unitOfTime: unitOfTimeType): number => {
	return moment().diff(moment(FROM_UTC(dateInUtc)), unitOfTime);
};

export const DIFFERENCE_IN_SECONDS = (dateToCompare: Date | string | moment.Moment): number => {
	return moment().diff(dateToCompare, 'seconds');
};
